module.exports = __webpack_public_path__ + "img/btn-play.156e47a4.png";